import React from "react";
import "../assets/css/fontawesome.css";
import "../assets/css/slick.css";
import "../assets/css/lightgallery.min.css";
import "../assets/css/animate.css";
import "../assets/css/style.css";

const Footer = () => {
  return (
    <>
      <section className="contact-section py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <h2
                className="contact-title"
                style={{
                  color: "#ffc107",
                  textTransform: "uppercase",
                  fontSize: "24px",
                  marginBottom: "30px",
                }}
              >
                CONTACT ME
              </h2>
              <form>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Your Name"
                    style={{
                      backgroundColor: "#333",
                      border: "none",
                      color: "#ddd",
                      marginBottom: "20px",
                    }}
                  />
                </div>
                <div className="form-group">
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Your Email"
                    style={{
                      backgroundColor: "#333",
                      border: "none",
                      color: "#ddd",
                      marginBottom: "20px",
                    }}
                  />
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Your Subject"
                    style={{
                      backgroundColor: "#333",
                      border: "none",
                      color: "#ddd",
                      marginBottom: "20px",
                    }}
                  />
                </div>
                <div className="form-group">
                  <textarea
                    className="form-control"
                    rows="5"
                    placeholder="Your Message"
                    style={{
                      backgroundColor: "#333",
                      border: "none",
                      color: "#ddd",
                      marginBottom: "20px",
                    }}
                  ></textarea>
                </div>
                <button
                  type="submit"
                  className="btn btn-primary btn-block"
                  style={{
                    backgroundColor: "#ffc107",
                    border: "none",
                    color: "#111",
                  }}
                >
                  Send Message
                </button>
              </form>
            </div>
            <div className="col-md-6 mt-5 gap-4">
              <div className="contact-info">
                <p>
                  If you have any questions or need further information, please
                  feel free to contact me.
                </p>
                <ul className="list-unstyled">
                  <li>
                    <strong>Email:</strong>{" "}
                    <a
                      href="mailto:techiedevmayowa@gmail.com"
                      style={{ color: "#ffc107" }}
                    >
                      techiedevmayowa@gmail.com
                    </a>
                  </li>
                  <li>
                    <strong>Phone:</strong> +234 9167 8933
                  </li>
                  <li>
                    <strong>Address:</strong> Ogbomosho Oyo State, Nigeria
                  </li>
                </ul>
                <p>Visit my social profile and get connected</p>
                <div className="social-icons">
                  <a
                    href="https://web.facebook.com/profile.php?id=100094385412890"
                    className="btn btn-outline-light btn-social"
                    style={{
                      color: "#ddd",
                      border: "1px solid #555",
                      marginRight: "10px",
                    }}
                  >
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a
                    href="https://www.linkedin.com/in/adebanjo-favour-%F0%9F%92%BB-217b1a251/"
                    className="btn btn-outline-light btn-social"
                    style={{
                      color: "#ddd",
                      border: "1px solid #555",
                      marginRight: "10px",
                    }}
                  >
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                  <a
                    href="https:/x.com/__MayowaDev02"
                    className="btn btn-outline-light btn-social"
                    style={{
                      color: "#ddd",
                      border: "1px solid #555",
                      marginRight: "10px",
                    }}
                  >
                    <i className="fab fa-twitter"></i>
                  </a>
                  <a
                    href="https://wa.me/+2349167638933"
                    className="btn btn-outline-light btn-social"
                    style={{
                      color: "#ddd",
                      border: "1px solid #555",
                      marginRight: "10px",
                    }}
                  >
                    <i className="fab fa-whatsapp"></i>
                  </a>
                  <a
                    href="mailto:techiedevmayowa@gmail.com"
                    className="btn btn-outline-light btn-social"
                    style={{
                      color: "#ddd",
                      border: "1px solid #555",
                      marginRight: "10px",
                    }}
                  >
                    <i className="fas fa-envelope"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Footer;
